import React from "react";
import {getBookingEngineTranslations} from "@assets/js/functions/helpers";
const translations = getBookingEngineTranslations();

const counterWidget = (counter, index) => {
    if (counter !== false) {
        return (
            <small>{translations['tabs-subheading-prefix']} {counter(index)} {translations['tabs-subheading-suffix']}</small>
        )
    }
}

export default ({heading, counter, activeTab, onTabClick, index}) => {
    return (
        <div
            className={`tabs__tab${index === activeTab ? ' active' : ''}`}
            onClick={() => onTabClick(index) }
        >
            <h3 className="tabs__heading">
                {heading}
                {counterWidget(counter, index)}
            </h3>
        </div>
    )
}
